import { Team__Nogaleras } from "../teams/Nogaleras";
import { Team__Potras } from "../teams/Potras";
import { Team__Pythons } from "../teams/Pythons";
import { Team__Raptors } from "../teams/Raptors";
import { Team__UTPaquime } from "../teams/UTPaquime";

const Nogaleras = {
  team: Team__Nogaleras,
  playingPlayers: [],

  goals: 31,
  penaltyGoals: 0,
  isWinner: false,
};

const Nogaleras_Match2 = {
  team: Team__Nogaleras,
  playingPlayers: [],

  goals: 40,
  penaltyGoals: 0,
  isWinner: false,
};

const Raptors = {
  team: Team__Raptors,
  playingPlayers: [],

  goals: 22,
  penaltyGoals: 0,
  isWinner: false,
};

const Raptors_Match2 = {
  team: Team__Raptors,
  playingPlayers: [],

  goals: 21,
  penaltyGoals: 0,
  isWinner: false,
};

const UTPaquime = {
  team: Team__UTPaquime,
  playingPlayers: [],

  goals: 25,
  penaltyGoals: 0,
  isWinner: false,
};

const Potras = {
  team: Team__Potras,
  playingPlayers: [],

  goals: 25,
  penaltyGoals: 0,
  isWinner: false,
};

const Pythons = {
  team: Team__Pythons,
  playingPlayers: [],

  goals: 23,
  penaltyGoals: 0,
  isWinner: false,
};

const Pythons_Match2 = {
  team: Team__Pythons,
  playingPlayers: [],

  goals: 37,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada3 = {
  jornadaPosition: 3,
  matches: [
    {
      team1: Pythons,
      team2: Raptors,

      isCompleted: true,
      isPlaying: true,
      day: "Miercoles",
      date: "2025-07-30",
      time: "11:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Nogaleras,
      team2: Potras,

      isCompleted: true,
      isPlaying: true,
      day: "Miercoles",
      date: "2025-07-30",
      time: "12:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: UTPaquime,
      team2: Raptors_Match2,

      isCompleted: true,
      isPlaying: true,
      day: "Miercoles",
      date: "2025-07-30",
      time: "16:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Nogaleras_Match2,
      team2: Pythons_Match2,

      isCompleted: true,
      isPlaying: true,
      day: "Miercoles",
      date: "2025-07-30",
      time: "17:00:00",
      location: "Centro Recreativo Lebaron",
    },
  ],
};
